exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.col-md-12[data-v-7f9e8331],h3[data-v-7f9e8331]{text-align:center}img[data-v-7f9e8331]{max-width:320px;margin:auto!important}", ""]);

// exports
